import { render, staticRenderFns } from "./RoasProduct.vue?vue&type=template&id=35fb037e&scoped=true&"
import script from "./RoasProduct.vue?vue&type=script&lang=js&"
export * from "./RoasProduct.vue?vue&type=script&lang=js&"
import style0 from "./RoasProduct.vue?vue&type=style&index=0&id=35fb037e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb037e",
  null
  
)

export default component.exports